import React from 'react'
import { injectIntl } from 'react-intl'
import { Body } from 'shared-global-ec-uikit/components/dist/react/esm/components/body'
import { LinkText } from 'shared-global-ec-uikit/components/dist/react/esm/components/link-text'
import { Display } from 'shared-global-ec-uikit/components/dist/react/esm'
import { ContentAlignment } from 'shared-global-ec-uikit/components/dist/react/esm/components/content-alignment'
import { ButtonIcon } from 'shared-global-ec-uikit/components/dist/react/esm/components/button-icon'
import Parser from 'html-react-parser'

import * as storesUtils from 'services/Stores/utils'

import getConstants from '../../../../constants'
import { BRAND_LIST, Countries } from '../../../../typings'
import { formatPostalCode } from 'helpers/address'

const StoreLocation = (props: any) => {
  const getAddressWithPickUpLocation = (props: any) => {
    const data = []
    const locationWording = props.intl.formatMessage({
      id: 'text_store_pickup_location_title',
    })
    data.push(props.storeInfo.address)
    const country = getConstants().COUNTRY
    const postalCode =
      props.storeInfo.postalCode &&
      formatPostalCode(props.storeInfo.postalCode, country)

    // Add postal code for JP
    // US and CA has postal code in their address
    if (country === Countries.JP && postalCode) {
      return (
        <>
          <Body element="p">{postalCode}</Body>
          {data.join(' ')}
        </>
      )
    }
    return data.join(' ')
  }

  return (
    <>
      <Display
        color="primary-dark"
        element="p"
        maxLinesEllipsis={0}
        textAlign="left"
        textTransform="normal"
        variant="display4"
        className="fr-ec-mb-spacing-04"
      >
        {props.intl.formatMessage({ id: 'text_address' })}
      </Display>
      <Body
        color="primary-dark"
        element="p"
        textAlign="left"
        textTransform="normal"
        variant="standard"
        className="fr-ec-mb-spacing-04"
      >
        {getAddressWithPickUpLocation(props)}
      </Body>
      <Body
        color="primary-dark"
        element="p"
        textAlign="left"
        textTransform="normal"
        variant="standard"
        className="fr-ec-mb-spacing-04"
      >
        <LinkText
          element="a"
          href={storesUtils.getDirectionLink({
            storeDetails: props.storeInfo,
          })}
          target="_blank"
          rel="noopener"
          ecRenewal
        >
          {props.intl.formatMessage({ id: 'text_showdirection' })}
        </LinkText>
      </Body>
      <Body
        color="primary-dark"
        element="p"
        textAlign="left"
        textTransform="normal"
        variant="standard"
        className="fr-ec-mb-spacing-04"
      >
        <LinkText
          element="a"
          href={`tel:${props.storeInfo.phone}`}
          target="_blank"
          rel="noopener"
          ecRenewal
        >
          {props.storeInfo.phone}
        </LinkText>
      </Body>

      {getConstants().BRAND === BRAND_LIST.PL ? (
        ''
      ) : (
        <Body
          color="primary-dark"
          element="p"
          textAlign="left"
          textTransform="normal"
          variant="standard"
          className="fr-ec-mb-spacing-04"
        >
          {props.intl.formatMessage({
            id: 'text_inventory_annotation2',
          })}
        </Body>
      )}
      {props.storeInfo.comment1 && (
        <ContentAlignment element="div" alignment="center">
          <LinkText
            element="a"
            href={Parser(props.storeInfo.comment1)}
            target="_blank"
            rel="noopener"
            ecRenewal
          >
            {props.intl.formatMessage({
              id: 'text_open_maps_with_popular_times',
            })}
          </LinkText>
          <ButtonIcon
            element="a"
            icon="external-link"
            href={Parser(props.storeInfo.comment1)}
            target="_blank"
            rel="noopener"
          />
        </ContentAlignment>
      )}
    </>
  )
}

export default injectIntl(StoreLocation)
